(function () {
  const sectionEl = document.querySelector('[id^="ScandalsProduct-"]');
  if (!sectionEl) return;

  const sectionId = sectionEl.id.replace("ScandalsProduct-", "");
  const variantPickerEl = document.getElementById(`spVariantPicker-${sectionId}`);
  if (!variantPickerEl) return;

  const productUrl = variantPickerEl.dataset.productUrl;
  const priceWrap = document.getElementById(`price-${sectionId}`);
  const addButton = sectionEl.querySelector(".sp-add-button");

  function updateProductInfo(variantId) {
    if (!variantId || !productUrl) return;

    fetch(`${productUrl}?variant=${variantId}&section_id=${sectionId}`)
      .then((res) => res.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, "text/html");

        const newPrice = doc.getElementById(`price-${sectionId}`);
        if (newPrice && priceWrap) {
          priceWrap.innerHTML = newPrice.innerHTML;
        }

        const newButton = doc.querySelector(".sp-add-button");
        if (newButton && addButton) {
          addButton.disabled = newButton.disabled;
          addButton.textContent = newButton.textContent;
        }
      })
      .catch((err) => console.error("[variant-picker] fetch error:", err));
  }

  // Watch the hidden variant input (updated by your existing inline script)
  const variantInput = sectionEl.querySelector('input[name="id"]');
  if (variantInput) {
    variantInput.addEventListener("change", () => {
      updateProductInfo(variantInput.value);
    });
  }

  // Fallback: listen directly on the picker for radio changes
  variantPickerEl.addEventListener("change", () => {
    setTimeout(() => {
      const currentInput = sectionEl.querySelector('input[name="id"]');
      if (currentInput) updateProductInfo(currentInput.value);
    }, 50);
  });
})();
